module.exports = __webpack_public_path__ + "static/media/english.1452bf79.png";